import dayjs from 'dayjs';
import { Schedule, TableFilters } from './types';

const isSameDate = (date1: string, date2: string | Date) => {
  return dayjs(date1).isSame(dayjs(date2), 'date');
};

const filterByKey = <T extends keyof Schedule>(
  data: Schedule[],
  key: T,
  value: string
) => {
  const lowerCaseValue = value.toLocaleLowerCase();
  return data.filter((row) => {
    const rowValue = row[key];
    return (
      typeof rowValue === 'string' &&
      rowValue.toLocaleLowerCase().includes(lowerCaseValue)
    );
  });
};

const filterByDate = <T extends keyof Schedule>(
  data: Schedule[],
  key: T,
  date: Date
) => {
  return data.filter((row) => {
    const rowValue = row[key];
    return isSameDate(rowValue as string, date);
  });
};

export const filterData = (data: Schedule[], filters: TableFilters) => {
  let filteredData = [...data];

  if (filters.shipName) {
    filteredData = filterByKey(filteredData, 'buque', filters.shipName);
  }

  if (filters.service) {
    filteredData = filterByKey(filteredData, 'servicio', filters.service);
  }

  if (filters.startOperations) {
    filteredData = filterByDate(
      filteredData,
      'comienzoOperaciones',
      filters.startOperations
    );
  }

  if (filters.endOperations) {
    filteredData = filterByDate(
      filteredData,
      'finOperaciones',
      filters.endOperations
    );
  }

  if (filters.openingStacking) {
    filteredData = filterByDate(
      filteredData,
      'aperturaStacking',
      filters.openingStacking
    );
  }

  if (filters.closingStacking) {
    filteredData = filterByDate(
      filteredData,
      'cierreStacking',
      filters.closingStacking
    );
  }

  return filteredData;
};
